import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { LoaderService } from "./loader.service";
import { Mail } from "../model/email";
import { Observable, map } from "rxjs";
import { ActionResult } from "@model";
import {EnvironmentService} from "./environment.service";

@Injectable({ providedIn: 'root' })
export class EmailService {
    constructor(private http: HttpClient, private loaderService: LoaderService, private environmentService:EnvironmentService) {
    }

    sendEmailToUser(email: Mail | undefined): Observable<ActionResult<boolean>> {
        this.loaderService.startLoading();
        return this.http.post<any>(this.environmentService.getApiUrl() + "/api/public/mail/send", email).pipe(map((value: any) => {
            if (value) {
                this.loaderService.dismissLoading();
                return value;
            } else {
                this.loaderService.dismissLoading();
                return [];
            }
        }));
    }
}
